import { apiClient } from './client';
import {
  BrgListItemDto,
  BrgColorKeyDto,
  BrgDetailDto,
  EngagementSummaryDto,
  CreateBrgRequest,
  UpdateBrgRequest,
} from '../types';

export const brgsApi = {
  list(): Promise<BrgListItemDto[]> {
    return apiClient.get<BrgListItemDto[]>('/api/brgs');
  },

  listColorKey(): Promise<BrgColorKeyDto[]> {
    return apiClient.get<BrgColorKeyDto[]>('/api/brgs/color-key');
  },

  getById(id: string): Promise<BrgDetailDto> {
    return apiClient.get<BrgDetailDto>(`/api/brgs/${id}`);
  },

  create(data: CreateBrgRequest): Promise<BrgDetailDto> {
    return apiClient.post<BrgDetailDto>('/api/brgs', data);
  },

  update(id: string, data: UpdateBrgRequest): Promise<BrgDetailDto> {
    return apiClient.patch<BrgDetailDto>(`/api/brgs/${id}`, data);
  },

  inactivate(id: string): Promise<void> {
    return apiClient.patch<void>(`/api/brgs/${id}/inactivate`);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete<void>(`/api/brgs/${id}`);
  },

  getEngagementSummary(): Promise<EngagementSummaryDto> {
    return apiClient.get<EngagementSummaryDto>('/api/brgs/engagement-summary');
  },
};
